// extracted by mini-css-extract-plugin
export default {"textoSemRegistro":"outrosRegimesTab_textoSemRegistro__q0Yn5","aba":"outrosRegimesTab_aba__tCTv5","stepContainer":"outrosRegimesTab_stepContainer__PaAVy"};